// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"23afee25","812":"f3927446"}[chunkId] + ".chunk.js";
};